import { darkModeMixin } from "../application/index";

export const layoutMixin = {
  mixins: [darkModeMixin],
  data() {
    return {
      loading: true,
    };
  },
  created() {
    this.$store.dispatch("DarkMode/makeDarkMode");
    this.loading = false;
  },
};
